import styled from "styled-components";
import { StyledButton } from "../Button/styling/Button.styles";

const TRANSITION_DURATION = 300;
const TRANSITION_TIMING_FUNCTION = "ease-in-out";

const StyledBidButton = styled(StyledButton)`
	position: relative;
	overflow: hidden;
	width: 100%;
	box-sizing: border-box;
	transition: background-color ${TRANSITION_DURATION}ms
		${TRANSITION_TIMING_FUNCTION};
`;

export const StyledBidButtonLabel = styled.div`
	@keyframes slideUpLabel {
		0% {
			top: 100%;
		}
		100% {
			top: 0;
		}
	}

	position: relative;
	display: flex;
	align-items: center;
	justify-content: space-between;
	flex: 1;
	transition: opacity ${TRANSITION_DURATION}ms ${TRANSITION_TIMING_FUNCTION};

	${({ theme }) => ({
		gap: theme.space.xs,
	})}
`;

export const StyledBidButtonSuccess = styled.div`
	@keyframes slideUpSuccess {
		0% {
			top: 100%;
			opacity: 0;
		}
		25%,
		75% {
			top: 0;
			opacity: 1;
		}
		100% {
			top: -100%;
			opacity: 0;
		}
	}

	position: absolute;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 100%;
	top: 100%;
	opacity: 0;
	box-sizing: border-box;

	${({ theme }) => {
		return {
			gap: theme.space.xs,
			padding: `0 ${theme.space.lg}`,
		};
	}}
`;

export default StyledBidButton;
